<template>
  <div>
    <RcSubscriberList
      :items="subscribers.data.results"
      :item="selected"
      @selected="onSelected"
    />
  </div>
</template>
<script>
import { mapState } from "vuex";

import {
  GET_SUBSCRIBERS,
  SET_SUBSCRIBER
} from "@/libvue/apps/subscribers/actions";

import RcSubscriberList from "#/pages/subscribers/components/SubscriberList.vue";

export default {
  components: {
    RcSubscriberList
  },
  props: {
    public: {
      type: Boolean,
      default: false
    },
    close: {
      type: Function,
      default: () => {}
    }
  },
  data() {
    return {
      selected: ""
    };
  },
  mounted() {
    const payload = {
      lat: window.geoip_latitude(),
      lon: window.geoip_longitude(),
      page_size: 6,
      radius: 100,
      ...(this.public && { type: "libraries" })
    };

    this.$store.dispatch(GET_SUBSCRIBERS, payload);
  },
  computed: {
    ...mapState({
      subscribers: (state) => state.subscribers.list
    })
  },
  methods: {
    onSelected(e) {
      this.close();

      this.$store.commit(SET_SUBSCRIBER, e);
      this.$router.replace({
        name: "auth.login",
        params: { locale: this.$i18n.locale }
      });
    }
  }
};
</script>

<style lang="scss"></style>
